'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const tslib_es6 = require('../../../tslib.es6-CZ43up4V.js');
const React = require('react');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_navigation_Link_Link = require('../Link/Link.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const baseButton = "_base-button_rr5dn_1";
const buttonContent = "_button-content_rr5dn_530";
const buttonText = "_button-text_rr5dn_538";
const buttonIcon = "_button-icon_rr5dn_546";
const styles = {
	baseButton: baseButton,
	buttonContent: buttonContent,
	buttonText: buttonText,
	buttonIcon: buttonIcon
};

const ButtonIcon = (props) => React__default.default.createElement(
  "span",
  { className: styles.buttonIcon, "data-has-sibling": props.hasSibling, "data-zds": true },
  React__default.default.createElement(components_display_Icon_Icon.Icon, { canAcceptPointerEvents: false, isBlock: true, name: props.iconName, size: props.size })
);
const ButtonText = (props) => React__default.default.createElement("span", { className: styles.buttonText, "data-zds": true }, props.children);
const ButtonContent = (props) => {
  return React__default.default.createElement(
    "span",
    { className: styles.buttonContent, "data-zds": true },
    props.iconBefore && React__default.default.createElement(ButtonIcon, { hasSibling: !!props.children, iconName: props.iconBefore, size: 24 }),
    React__default.default.createElement(ButtonText, null, props.children)
  );
};
const getTag = (props) => {
  if (props.presentationOnly) {
    return "span";
  }
  if (props.htmlFor && !props.disabled) {
    return "label";
  }
  if (props.href && !props.disabled) {
    return components_navigation_Link_Link.Link;
  }
  return "button";
};
function BaseButton(_a) {
  var { disabled = false, isFullWidth = false, isPill = false } = _a, otherProps = tslib_es6.__rest(_a, ["disabled", "isFullWidth", "isPill"]);
  const props = Object.assign({
    disabled,
    isFullWidth,
    isPill
  }, otherProps);
  const ButtonTag = getTag(props);
  const isLink = ButtonTag === components_navigation_Link_Link.Link;
  return React__default.default.createElement(
    ButtonTag,
    {
      "aria-controls": props["aria-controls"],
      "aria-describedby": props["aria-describedby"],
      "aria-disabled": props["disabled"],
      "aria-expanded": props["aria-expanded"],
      "aria-haspopup": props["aria-haspopup"],
      "aria-hidden": props["aria-hidden"],
      "aria-label": props["aria-label"],
      className: styles.baseButton,
      // @ts-ignore TS doesn't understand Link[color=null]
      color: isLink ? null : void 0,
      "data-a11y-ignore": props.color === "brand" ? "color-contrast" : void 0,
      "data-color": props.color,
      "data-icon": props.iconBefore ? "before" : void 0,
      "data-full-width": props.isFullWidth ? "" : void 0,
      "data-pill": props.isPill ? "" : void 0,
      "data-selected": props.isSelected ? "" : void 0,
      "data-shadowed": props.hasShadow ? "" : void 0,
      "data-size": props.size,
      "data-square": props.isSquare ? "" : void 0,
      "data-zds": true,
      disabled: props.disabled,
      htmlFor: props.htmlFor,
      href: isLink ? props.href : void 0,
      id: props.id,
      onClick: props.onClick,
      onKeyDown: props.onKeyDown,
      rel: isLink ? props.rel : void 0,
      role: !isLink ? "button" : void 0,
      tabIndex: props.tabIndex,
      target: isLink ? props.target : void 0,
      type: ButtonTag === "button" ? props.type : void 0
    },
    React__default.default.createElement(ButtonContent, Object.assign({}, props))
  );
}

exports.BaseButton = BaseButton;
//# sourceMappingURL=BaseButton.cjs.js.map
